import { render, staticRenderFns } from "./SelGoods.vue?vue&type=template&id=37fd6f96&scoped=true&"
import script from "./SelGoods.vue?vue&type=script&lang=js&"
export * from "./SelGoods.vue?vue&type=script&lang=js&"
import style0 from "./SelGoods.vue?vue&type=style&index=0&id=37fd6f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd6f96",
  null
  
)

export default component.exports